import type { Role, RoleId } from '~/types/user/user-roles'

export const ROLES = {
  FIZ: 'fiz',
  COMPANY: 'company',
  VACANCY_ADMIN: 'vacancy_admin',
  VACANCY_MANAGER: 'vacancy_manager',
  DIGITAL_PROFILES: 'digital_profiles',
  REPORTS_MANAGER: 'reports_manager',
  TUTOR: 'tutor',
  UNIVERSITY: 'university',
} as const

export const ROLE_GROUPS = {
  COMPANY_ROLES: [ROLES.COMPANY, ROLES.VACANCY_ADMIN, ROLES.VACANCY_MANAGER],
  PHYSICAL_ROLES: [ROLES.FIZ],

  // Все авторизованные пользователи
  ALL_AUTHENTICATED: [
    ROLES.FIZ,
    ROLES.UNIVERSITY,
    ROLES.COMPANY,
    ROLES.VACANCY_ADMIN,
    ROLES.VACANCY_MANAGER,
    ROLES.DIGITAL_PROFILES,
    ROLES.TUTOR,
    ROLES.REPORTS_MANAGER,
  ],

  // Административные роли
  ADMIN_ROLES: [ROLES.VACANCY_ADMIN],

  // Публикации
  PUBLISHER_ROLES: [ROLES.UNIVERSITY],

  // Цифровые профили
  DIGITAL_ROLES: [ROLES.DIGITAL_PROFILES],

  // Наставничество
  TUTOR_ROLES: [ROLES.TUTOR],

  // Отчеты
  REPORTS_ROLES: [ROLES.REPORTS_MANAGER],

  // Работодатели (все, кто может создавать вакансии)
  EMPLOYER_ROLES: [ROLES.COMPANY, ROLES.VACANCY_ADMIN, ROLES.VACANCY_MANAGER],

  // Менеджеры вакансий
  VACANCY_MANAGER_ROLES: [ROLES.VACANCY_ADMIN, ROLES.VACANCY_MANAGER],
} as const


const roleFiz: Role = {
  allowedRoutes: [/^\/account\/?$/, /^\/account\/candidate.*/, /^\/account\/my-profile.*/],
  defaultRoute: '/account/candidate/resumes',
}

const roleUniversity: Role = {
  allowedRoutes: [/^\/account\/?$/, /^\/account\/publish.*/],
  defaultRoute: '/account/publish/settings',
}

const roleCompany: Role = {
  allowedRoutes: [
    /^\/account\/?$/,
    /^\/account\/vacancies.*/,
    /^\/account\/resumes-subscriptions.*/,
    /^\/account\/career-routes.*/,
    /^\/account\/event-schedule.*/,
    /^\/account\/executive-search\/?$/,
    /^\/account\/employer-page.*/,
  ],
  defaultRoute: '/account/vacancies',
}

const roleDigitalProfiles: Role = {
  allowedRoutes: [
    /^\/account\/?$/,
    /^\/account\/university-statistics.*/,
    /^\/account\/career-routes.*/,
  ],
  defaultRoute: '/account/university-statistics',
}

const roleTutor: Role = {
  allowedRoutes: [
    /^\/account\/?$/,
    /^\/account\/tutor(\/profile\/(create|edit))?$/,
    /^\/account\/tutor(\/slot\/(create|edit\/[\w-]+))?$/,
  ],
  defaultRoute: '/account/tutor',
}

const vacancyAdmin: Role = {
  allowedRoutes: [
    /^\/account\/?$/,
    /^\/account\/users.*/,
    /^\/account\/companies.*/,
    /^\/account\/vacancies.*/,
    /^\/account\/resumes-subscriptions.*/,
    /^\/account\/career-routes.*/,
    /^\/account\/event-schedule.*/,
    /^\/account\/executive-search\/?$/,
    /^\/account\/employer-page.*/,
  ],
  defaultRoute: '/account/users',
}

const vacancyManager: Role = {
  allowedRoutes: [
    /^\/account\/?$/,
    /^\/account\/vacancies.*/,
    /^\/account\/resumes-subscriptions.*/,
    /^\/account\/career-routes.*/,
    /^\/account\/event-schedule.*/,
    /^\/account\/executive-search\/?$/,
  ],
  defaultRoute: '/account/vacancies',
}

const reportsManager: Role = {
  allowedRoutes: [/^\/account\/?$/, /^\/account\/reports.*/],
  defaultRoute: '/account/reports',
}

const roles: { [key in RoleId]: Role } = {
  fiz: { ...roleFiz },
  university: { ...roleUniversity },
  company: { ...roleCompany },
  digital_profiles: { ...roleDigitalProfiles },
  tutor: { ...roleTutor },
  vacancy_admin: { ...vacancyAdmin },
  vacancy_manager: { ...vacancyManager },
  reports_manager: { ...reportsManager },
}

export default roles
